import { useStores } from '@/api';
import AnnouncementLady from '@/assets/svg/announcement-lady.svg?react';
import { State } from '@/components/atoms';
import { PageHeader, StoreCard } from '@/components/molecules';
import { routes } from '@/lib/constants';
import { useNavigate } from 'react-router';

export const StorePage = () => {
  const navigate = useNavigate();
  const { data: stores } = useStores();

  return (
    <div className="flex flex-col gap-12">
      <PageHeader
        heading="Store"
        description="Manage your store and publish it to the world."
      />
      {stores && stores?.length < 1 ? (
        <State
          Icon={AnnouncementLady}
          heading="Build your store in 2mins!"
          button={{
            text: 'Start now',
            onClick: () => navigate(routes.storeBuilder),
          }}
        />
      ) : (
        <div className="grid grid-cols-6 gap-2">
          {stores?.slice(0, 1)?.map((store, index) => (
            <StoreCard
              key={store?.id || index}
              name={store?.name}
              description={store?.description}
              domain={store?.domain}
              image={store?.cover?.url}
              handleClick={() =>
                navigate(`${routes.storeBuilder}?id=${store?.id}`)
              }
              className="col-span-6 lg:col-span-3"
            />
          ))}
        </div>
      )}
    </div>
  );
};
